import { Controller } from "@hotwired/stimulus"

// Cascading filter for bay sizes: selecting a client narrows
// the category dropdown to categories where that client has
// warehouse stocks for the selected retailer(s).
export default class extends Controller {
  static targets = ["clientSelect", "categorySelect"]
  static values = { url: String }

  clientChanged() {
    this.updateCategories()
  }

  retailerChanged() {
    if (this.hasClientSelectTarget && this.clientSelectTarget.value) {
      this.updateCategories()
    }
  }

  async updateCategories() {
    const clientId = this.clientSelectTarget.value
    if (!clientId) {
      this.restoreCategorySelect()
      return
    }

    const retailerSelect = this.element.querySelector("[name='q[retailer_category_retailer_name_in][]']")
    const retailerNames = retailerSelect ? Array.from(retailerSelect.selectedOptions).map(o => o.value).filter(Boolean) : []

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("client_id", clientId)
    retailerNames.forEach(name => url.searchParams.append("retailer_names[]", name))

    try {
      const response = await fetch(url, { headers: { "Accept": "application/json" } })
      if (!response.ok) return

      const categories = await response.json()
      this.rebuildCategorySelect(categories)
    } catch (error) {
      console.error("Failed to fetch categories for client:", error)
    }
  }

  rebuildCategorySelect(categories) {
    if (!this.hasCategorySelectTarget) return

    const select = this.categorySelectTarget
    const currentValues = Array.from(select.selectedOptions).map(o => o.value)

    // Destroy SlimSelect if active
    const slim = select.slim
    if (slim) slim.destroy()

    select.innerHTML = ""
    categories.forEach(name => {
      const option = document.createElement("option")
      option.value = name
      option.textContent = name
      if (currentValues.includes(name)) option.selected = true
      select.appendChild(option)
    })

    // Re-init SlimSelect via a change event so the slim controller picks it up
    select.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
